import React, { useState } from "react";
import Signifier from "../../Components/Signifier";
import { makeStyles } from "@material-ui/core/styles";
import { Card, List, Paper, Tooltip, Dialog } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import PermissionsModal from "../../Components/Modal/PermissonsModal";
import ListSkeleton from "../../Components/Skeleton/ListSkeleton";

/** @param {{ unassignedBaseClients: any, populate: any, loading: any, user?: { id: string, firstName: string } }} props */
function NotAssignedTable({ unassignedBaseClients, populate, loading, user }) {
  const useStyles = makeStyles((theme) => ({
    root: {
      [theme.breakpoints.down("sm")]: {
        maxWidth: "unset",
        width: "100%",
        height: "500px",
      },
      height: "80vh",
      maxWidth: "2400px",
    },
    cardContainer: {
      [theme.breakpoints.down("sm")]: {
        maxWidth: "none",
        width: "100%",
      },
      width: "85%",
      height: "90%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      overflow: "auto",
    },
    listSection: {
      background: theme.palette.primary.blue,
      borderBottom: "1px solid #D1D1D1",
      padding: "5px",
      display: "flex",
      justifyContent: "space-between",
      cursor: "pointer",
      textDecoration: "none",
      "&:hover": {
        background: "rgba(0,0,0,.2) !important",
      },
    },
    listSectionOdd: {
      borderBottom: "1px solid #D1D1D1",
      padding: "5px",
      display: "flex",
      justifyContent: "space-between",
      cursor: "pointer",
      textDecoration: "none",
      "&:hover": {
        background: "rgba(0,0,0,.2) !important",
      },
    },
    listItem: {
      width: "33%",
      display: "flex",
      flexDirection: "row",
      fontSize: "14px",
      paddingLeft: "40px",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        paddingLeft: "0",
      },
    },
    listItemEnd: {
      width: "33%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      paddingRight: "40px",
      [theme.breakpoints.down("sm")]: {
        paddingRight: "0",
      },
    },
    labelSection: {
      position: "relative",
      width: "85%",
      display: "flex",
      marginTop: "10px",
      justifyContent: "space-between",
      background: "rgba(0,0,0,.1)",
      paddingTop: "10px",
      paddingBottom: "10px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
      "& span": {
        padding: "0px 70px 0px 40px",
        fontSize: "18px",
        fontWeight: "bold",
        [theme.breakpoints.down("sm")]: {
          padding: "0px 15px 0px 5px",
        },
      },
    },
    icon: {
      borderRadius: "30%",
      padding: "10px",
      cursor: "pointer",
      transition: ".2s",
      "&:hover": {
        background: "rgba(0,0,0,.1)",
      },
    },
  }));

  const classes = useStyles();

  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState([]);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState(false);
  const [showError, setShowError] = useState(false);

  const initModal = (data) => {
    setData(data);
    setOpenModal(true);
  };

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
        errorMessage="No careers client exists for this base client"
      />
      <div className={classes.root}>
        <Paper square elevation={1} className={classes.labelSection}>
          <span>Base Client</span>
          <span></span>
        </Paper>
        <Card elevation={0} square className={classes.cardContainer}>
          {loading ? (
            <ListSkeleton numRows={25} />
          ) : (
            <List classes={{ root: classes.list }}>
              {unassignedBaseClients.map((baseClient, index) => (
                <div className={index % 2 ? classes.listSection : classes.listSectionOdd} key={index}>
                  <span className={classes.listItem}>{baseClient.clientName}</span>
                  <span className={classes.listItemEnd} onClick={() => initModal(baseClient)}>
                    <Tooltip title="Add Permissions" aria-label="Add">
                      <Add className={classes.icon} />
                    </Tooltip>
                  </span>
                </div>
              ))}
            </List>
          )}
        </Card>
      </div>
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <PermissionsModal
          closeModal={() => setOpenModal(false)}
          client={data}
          setResponseMessage={setResponseMessage}
          setShowError={setShowError}
          setShowSignifier={setShowSignifier}
          populate={populate}
          user={user}
        />
      </Dialog>
    </>
  );
}

export default NotAssignedTable;
